module.exports = __webpack_public_path__ + "static/media/i2.1758131a.jpg";